var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAltimateLogoTransparent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7396 25.5596C39.9826 24.5245 38.7578 23.8518 37.377 23.8518C36.8561 23.8518 36.3571 23.9479 35.8977 24.1232C35.5824 24.2421 35.2848 24.4166 35.0117 24.6054C34.7723 24.7706 32.4963 26.7474 32.4963 26.7474L24.8869 33.2761L12 44.4438L27.7159 18.9028C28.6786 17.2767 30.3459 16.0013 32.2932 16.0013C33.8779 16.0013 35.2848 16.7592 36.1725 17.9334L36.7086 18.8295L38.4113 21.6719L40.7396 25.5596Z",
    fill: "url(#paint0_linear_13558_176566)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9312 43.4516C43.5361 44.0914 38.1066 44.4176 36.2648 44.3628C35.4707 44.3392 34.7103 44.2642 33.9871 44.1378C28.6326 43.2071 25.2861 39.4964 24.8899 33.2771H33.5749C33.7991 34.3468 34.0714 35.3407 34.3942 36.2553C35.4218 39.1803 36.9526 41.3029 39.0077 42.5378C39.1974 42.6516 39.3913 42.7578 39.5902 42.8565C40.4104 43.2653 41.3082 43.5426 42.2826 43.6851C42.2936 43.6868 42.3037 43.6885 42.3147 43.6901C42.5827 43.7365 42.8786 43.7862 43.1593 43.7862C43.7848 43.7862 44.3816 43.6682 44.9304 43.4516H44.9312Z",
    fill: "url(#paint1_linear_13558_176566)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9872 38.9383C47.9872 40.9875 46.7143 42.7392 44.9163 43.4464C44.9154 43.4464 44.9154 43.4464 44.9154 43.4464H44.9146C44.3658 43.663 43.769 43.7811 43.1436 43.7811C42.8628 43.7811 42.567 43.7313 42.2989 43.685C42.288 43.6833 42.2778 43.6816 42.2669 43.6799C41.2924 43.5374 40.3947 43.2601 39.5745 42.8513C39.6807 42.6835 39.7776 42.509 39.8484 42.3227C40.0634 41.7529 40.0853 40.8594 39.9774 40.2895C39.8467 39.5949 39.5467 38.9551 39.1833 38.3027L35.3201 31.6391L33.2009 27.9807L32.4835 26.7432C32.4835 26.7432 34.7595 24.7665 34.9989 24.6013C35.272 24.4124 35.5696 24.2379 35.8849 24.1191C36.3443 23.9438 36.8433 23.8477 37.3642 23.8477C38.745 23.8477 39.9698 24.5203 40.7268 25.5555L41.1213 26.213L46.9487 35.9416L47.3044 36.5358C47.7098 37.2127 47.9568 37.9781 47.9838 38.7672C47.9863 38.8236 47.9872 38.881 47.9872 38.9383Z",
    fill: "url(#paint2_linear_13558_176566)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13558_176566",
    x1: 37.0783,
    y1: 19.1071,
    x2: 9.65166,
    y2: 45.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0752364,
    stopColor: "#18529F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77433,
    stopColor: "#247EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13558_176566",
    x1: 24.9093,
    y1: 34.5896,
    x2: 41.937,
    y2: 45.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B5EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13558_176566",
    x1: 34.6611,
    y1: 24.9789,
    x2: 45.0192,
    y2: 42.3417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30FAFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltimateLogoTransparent);
export default __webpack_public_path__ + "static/media/altimateLogoTransparent.729a55123694e00f360028e5e767af0f.svg";
export { ForwardRef as ReactComponent };